<template>
    <div class="register">
        <b-modal id="register-modal" title="Register" size="md" centered hide-footer @show="resetModal" @hidden="resetModal" @ok="handleOk" no-stacking>
			<form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group label="Your name" label-for="name-input" label-size="sm" label-class="mb-0" class="mb-1">
                    <b-form-input id="name-input" v-model="register.name" ></b-form-input>
                </b-form-group>
                <b-form-group :state="emailState" label="Email" label-for="email-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Email should be valid">
                    <b-form-input id="mobile-input" v-model="register.email" :state="emailState"></b-form-input>
                </b-form-group>
                <b-form-group :state="mobileState" label="Mobile" label-for="mobile-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Mobile should be valid">
                    <b-form-input id="mobile-input" v-model="register.mobile" :state="mobileState"></b-form-input>
                </b-form-group>
                <b-form-group :state="passwordState" label="Password" label-for="password-input" label-size="sm" label-class="mb-0" class="mb-3" invalid-feedback="Password should be greater than 4 digits">
                    <b-form-input id="password-input" v-model="register.password" :state="passwordState"></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary" class="mr-2">Register</b-button>
                <b-button type="reset" variant="light" @click="handleCancel()">Cancel</b-button>
			</form>
		</b-modal>
    </div>
</template>

<script>
export default {
    name: 'Quickview',
    data() {
        return{
            url: this.$root.WEBURL+'customerregister',
            register: {
                name: '',
                email: '',
                mobile: '',
                password: '',
            },
            emailState: null,
            mobileState: null,
            passwordState: null,
        }
    },
    methods:{
        checkFormValidity() {
            var valid = true;
            if(this.register.email.length < 10){
                valid = false;
                this.emailState = false;
            }else{
                this.emailState = true;
            }
            if(this.register.mobile.length < 10){
                valid = false;
                this.mobileState = false;
            }else{
                this.mobileState = true;
            }
            if(this.register.password.length < 4){
                valid = false;
                this.passwordState = false;
            }else{
                this.passwordState = true;
            }
            return valid;
        },
        resetModal(){
            this.register.name = '';
            this.register.email = '';
            this.register.mobile = '';
            this.register.password = '';
            this.emailState = null;
            this.mobileState = null;
            this.passwordState = null;
        },
        handleOk(bvModalEvt){
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },
        handleCancel(){
            this.$bvModal.hide('register-modal');
        },
        handleSubmit(){
            if (!this.checkFormValidity()) {
                return;
            }
            var self = this;
            

            var o = {
                name: this.register.name,
                email: this.register.email,
                mobile: this.register.mobile,
                password: this.register.password
            }
            o.share_user_id = 0;
            if(self.$session.has('share_user_id')){
                o.share_user_id = self.$session.get('share_user_id');
            }
            
			self.axios.post(self.url, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Register',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
					});
					//self.$root.flash_msg.msg = response.data.message;
                    self.$session.remove('share_user_id');
                    self.$bvModal.hide('register-modal');
				}else{
					self.error_msg = response.data.message;
				}
			})
			.catch(function (error) {
				alert(error);
			});

            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>
